import { StoredSpot } from '../types/Individualization'
import { fabric } from 'fabric'

export const loadClipPath = (spot: StoredSpot, color?: string, strokeWidth?: number): fabric.Object => {
    const { type, ...rest } = spot.fabric
    let element:
        | fabric.Circle
        | fabric.Ellipse
        | fabric.Rect
        | fabric.Polygon
        | fabric.Object = new fabric.Object()
    const spotSettings = {
        ...rest,
        selectable: false,
        strokeDashArray: [10],
        fill: 'transparent',
        stroke: color || '#525252',
        opacity: 0.8,
        strokeWidth: strokeWidth,
        hoverCursor: 'default',
        absolutePositioned: true,
        data: {
            spot_id: spot.id,
            template_id: spot.template_id,
            is_clip_path: true,
        },
    }

    switch (type) {
        case 'circle':
            element = new fabric.Circle(spotSettings)
            break
        case 'rect':
            element = new fabric.Rect(spotSettings)
            break
        case 'ellipse':
            element = new fabric.Ellipse(spotSettings)
            break
        case 'polygon':
            element = new fabric.Polygon([], spotSettings)
            break
        default:
            break
    }

    return element as fabric.Object
}
